<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-back="false" :has-nav="false">
    <div class="o-y-auto" style="background-color: #F4F8FF;height: calc(100% - 40px)">
      <div class="w-full o-hidden" style="min-height: calc(100% - 64px)">
        <div class="m-auto bg-white" style="width: 820px;margin-bottom: 20px">
          <div class="m-auto" style="width: 740px;padding-top: 20px">
            <div style="width: 540px;">
              <up-load-image @uploadSuccess="uploadCoverImageSuccess" accept="image/*"
                             class="o-hiddden" picurl="common/desc/"
                             style="width:540px;height: 394px;">
                <template v-slot:tip>
                  <div class="w-full h-full">
                    <div class="flex-column a-center j-center w-full h-full"
                         style="background-color: #F6F9FF;cursor: pointer"
                         v-if="!coverUrl">
                      <img alt="" src="../../../assets/common/ic_upload_picture@2x.png"
                           style="width: 96px;height: 96px">
                      <span class="m-t-5  color-66">上传图片</span>
                    </div>
                    <div class="w-full h-full" style=" position: relative;left: 0;top: 0">
                      <div class="w-full h-full o-hidden flex a-center j-center"
                           style="position: absolute;width: 540px;">
                        <img :src="coverUrl" @click.stop="" class="w-full "
                             style="left: 0;top: 0;background-color: #F6F9FF; min-height: 394px;"
                             v-if="coverUrl"/>
                      </div>
                      <img @click.stop="coverUrl=''" class="van-icon-delete"
                           src="../../../assets/common/ic_delete_circle_red.png"
                           style="position:absolute;top: -12px;right: -12px;cursor: pointer" v-if="coverUrl"/>
                    </div>
                  </div>
                </template>
              </up-load-image>
            </div>
          </div>
          <div class="color-66 fs-12 m-t-15"
               style="padding-left: 40px;">
            图片格式为jpg或png,图片比例为4:3,图片大小不超过5Mb
          </div>
          <div class="m-t-10 p-h-40">
            <Row :gutter="15">
              <Col span="12">
                <class-vertical-choose-widget :objData="objData" :srcType="6"
                                              direction="horizontal"></class-vertical-choose-widget>
              </Col>
              <Col span="12">
                <div class="w-full" style="height: 80px;">
                  <span class="bold fs-14 color-33">图片标题:</span>
                  <Input class="m-t-10 w-full" maxlength="60" placeholder="图片标题" type="text" v-model="title"/>
                </div>
              </Col>
            </Row>
          </div>

        </div>
      </div>

      <div class="m-auto bg-white flex a-center j-end"
           style="width: 820px;position: sticky;bottom: 0;left: 0;height: 64px;box-shadow: 0px 0px 8px 0px rgba(1, 0, 52, 0.12);">
        <Button @click="onCancelClick" style="width: 76px">取消</Button>
        <Button @click="onPicSaveClick" class="m-l-20" style="  margin-right: 38px;width: 76px" type="primary">保存
        </Button>
      </div>
    </div>
  </base-page-component>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import {mapActions, mapMutations} from 'vuex'
import ClassVerticalChooseWidget from '../../../components/common/ClassVerticalChooseWidget'

export default {
  name: 'EditPic',
  components: {
    ClassVerticalChooseWidget,
    BasePageComponent,
    UpLoadImage,
  },
  data () {
    return {
      imgId: 0,
      title: '',
      coverUrl: '',
      width: 0,
      height: 0,
      objData: {
        classId: 0,
        groupId: 0,
        init: false
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.imgId = parseInt(this.$route.query.imgId || 0)
      if (this.imgId) {
        this.getPicDetails()
      }
    },
    getPicDetails () {
      let id = this.imgId
      let params = {}
      this.getPicDetail({id, params}).then(res => {
        if (res.code === 0) {
          let data = res.data
          this.title = data.title || ''
          this.coverUrl = data.url || ''
          this.width = data.width || 0
          this.height = data.height || 0
          this.objData = {
            classId: data.categoryId || 0,
            groupId: data.groupId || 0,
            init: true
          }
        }
      })
    },
    /**
     *上传封面
     * @param data
     */
    uploadCoverImageSuccess (data) {
      if (data && data.length) {
        console.log(data[0])
        this.coverUrl = data[0].url
        this.width = data[0].width
        this.height = data[0].height
        this.title = data[0].oldname || ''
      }
    },
    onPicSaveClick () {
      if (!this.coverUrl) {
        return this.$Message.info('请上传图片')
      }
      if (!this.title) {
        return this.$Message.info('请输入图片标题')
      }
      let id = this.imgId
      let params = {
        title: this.title,
        url: this.coverUrl,
        width: this.width,
        height: this.height,
        groupId: this.objData.groupId || 0,
        categoryId: this.objData.classId || 0,
        desc: ''
      }
      this.editPic({id, params}).then(res => {
        if (res.code === 0) {
          this.$router.go(-1)
          this.closeTag({
            name: 'EditPic'
          })
        }
      })

    },
    onCancelClick () {
      this.$router.go(-1)
      this.closeTag({
        name: 'EditPic'
      })
    },
    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'getPicDetail',
      'editPic',
    ]),
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
  .hoverstyle {
    &:hover {
      .showdel {
        display: block;
      }
    }

    .showdel {
      display: none;
    }
  }

</style>
